import { fetchQuery, graphql } from "relay-runtime"
import {
  chQuestionnaireSummarizerQuery as chQuestionnaireSummarizerQueryType,
  SummarizeQuestionnaireInput,
} from "@/modules/chats/services/ai/ch/__generated__/chQuestionnaireSummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chQuestionnaireSummarizerQuery($input: SummarizeQuestionnaireInput!) {
    summarizeQuestionnaire: ch_summarizeQuestionnaire(input: $input) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chQuestionnaireSummarizerQuery = (input: SummarizeQuestionnaireInput) => {
  return fetchQuery<chQuestionnaireSummarizerQueryType>(RelayEnvironment, query, { input }).toPromise()
}
